export const CUSTOM_FEEDBACK_PROPS = {
  disabled: {
    type: Boolean,
    required: true,
  },
} as const
